interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新不重样',
    desc: '每天早 8 点准时更新当日爆料合集，全天候追踪热点，最新爆料、娱乐爆料、网友爆料滚动刷新，让你每天都有新瓜可吃，绝不错过任何一条猛料。',
  },
  {
    icon: 'ri-stack-line',
    title: '多源聚合全覆盖',
    desc: '整合 30+ 信源渠道，涵盖明星动态、综艺热点、网红翻车、行业大瓜等多元话题，文字截图摘要形式呈现，一页看尽全网爆料合集。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '匿名投稿零风险',
    desc: '支持网友匿名爆料投稿，严格保护爆料人隐私，绝不追踪、不泄露。每一条投稿都经过人工审核筛选，确保内容质量与安全合规。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">
            为什么百万吃瓜群众选择每日大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl border border-background-200/70 p-6 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}